var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 20.988C11.333 19.6768 12.2778 18.5599 13.5619 18.3533C15.1769 18.0934 16.8225 18.0934 18.4375 18.3533C19.7215 18.5599 20.6663 19.6768 20.6663 20.988V21.2783C20.6663 22.0452 20.0499 22.6668 19.2894 22.6668H12.7099C11.9495 22.6668 11.333 22.0452 11.333 21.2783V20.988Z",
    stroke: "#363853",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7219 12.0786C18.7219 13.5947 17.5031 14.8237 15.9997 14.8237C14.4962 14.8237 13.2775 13.5947 13.2775 12.0786C13.2775 10.5625 14.4962 9.3335 15.9997 9.3335C17.5031 9.3335 18.7219 10.5625 18.7219 12.0786Z",
    stroke: "#363853",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.33333C28 6.38781 25.0152 4 21.3333 4M4 21.3333C4 25.0152 6.38781 28 9.33333 28M9.33333 4C6.38781 4 4 6.38781 4 9.33333M21.3333 28C25.0152 28 28 25.0152 28 21.3333",
    stroke: "#363853",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserScan);
export default __webpack_public_path__ + "static/media/User-scan.c3547ce73a22f439bce4a8ec60521d73.svg";
export { ForwardRef as ReactComponent };